"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBeerGlassFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4.006 7c-.104 1.227.5 2.5 1 3v10c0 2 2 2 2 2h8s2 0 2-2v-1s3-.5 3-4v-2c0-2-2-2-2-2h-1v-1s1-1 1-2.5c0-2.948-3-3.5-3-3.5s-1.344-2-4-2c-2.656 0-4 2-4 2-1.88.383-2.902 1.839-3 3zm2.405-.512c-.511.546-.443 1.133-.314 1.52.9-.008.9.992.9.992v3.034s-.02.966.997.966 1.017-.966 1.017-.966V9s-.017-1 .983-1c2.703 0 5.92.009 5.92.009.158-.458.129-1.145-.37-1.599-.498-.454-1.329-.397-1.648-.298-.248-.685-1.066-2.108-2.89-2.108-1.876 0-2.603 1.387-2.876 2.121-.312-.125-1.074-.324-1.719.363zM17.994 16c0 .5-.5 1-1 1v-4h1v3zm-6-4h1v6h-1v-6zm-3 4h1v2h-1v-2z' }))); };
exports.default = SvgBeerGlassFilled;
//# sourceMappingURL=BeerGlassFilled.js.map